import * as React from 'react';
import { Field, FieldArray } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';
import Input from 'af-fields/Input';

import AdditionalTrucksAndEquipment from './AdditionalTrucksAndEquipment';
import JobUpsertFM from '../../../formModel';
import { formSectionClass, formSectionClassColumn1, formSectionClassRow } from '../../../helpers';
import styles from '../../../styles.module.scss';

interface OwnProps {
	isDisabled: boolean;
}

type Props = OwnProps;

const TrucksAndEquipmentSection: React.FC<Props> = (props) => {
	const { isDisabled } = props;
	const columnClassName = React.useMemo(() => [formSectionClassColumn1, styles['job-form__trucks-and-equipment__column']].join(' '), []);
	const fieldColumnClassName = React.useMemo(() => [styles['job-form__trucks-and-equipment__number-of-employees__field-column']].join(' '), []);
	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Trucks / Equipment"
				tooltip="Inventory items and resources allocated for this job, including the equipment to be deployed and the number of staff required on site."
			/>
			<div className={formSectionClassRow}>
				<div className={columnClassName}>
					<Field
						component={Checkbox}
						id="jc80gpm"
						isDisabled={isDisabled}
						label="JC (80 gpm)"
						name={JobUpsertFM.getAttributeName('jc80gpm')}
					/>
					<Field
						component={Checkbox}
						id="sjc80gpm"
						isDisabled={isDisabled}
						label="SJC (80 gpm)"
						name={JobUpsertFM.getAttributeName('sjc80gpm')}
					/>
					<Field
						component={Checkbox}
						id="jcRecycler80"
						isDisabled={isDisabled}
						label="JC Recycler (80 gpm)"
						name={JobUpsertFM.getAttributeName('jcRecycler80')}
					/>
					<Field
						component={Checkbox}
						id="jjc120gpm"
						isDisabled={isDisabled}
						label="JJC (120 gpm)"
						name={JobUpsertFM.getAttributeName('jjc120gpm')}
					/>
					<Field
						component={Checkbox}
						id="jjc160gpm"
						isDisabled={isDisabled}
						label="JJC (160 gpm)"
						name={JobUpsertFM.getAttributeName('jjc160gpm')}
					/>
					<Field
						component={Checkbox}
						id="jcHiRail"
						isDisabled={isDisabled}
						label="JC HiRail"
						name={JobUpsertFM.getAttributeName('jcHiRail')}
					/>
					<Field
						component={Checkbox}
						id="jetter"
						isDisabled={isDisabled}
						label="Jetter"
						name={JobUpsertFM.getAttributeName('jetter')}
					/>
					<Field
						component={Checkbox}
						id="harbenJetter"
						isDisabled={isDisabled}
						label="Harben Jetter"
						name={JobUpsertFM.getAttributeName('harbenJetter')}
					/>
				</div>
				<div className={columnClassName}>
					<Field
						component={Checkbox}
						id="hjJetter"
						isDisabled={isDisabled}
						label="HJ Jetter"
						name={JobUpsertFM.getAttributeName('hjJetter')}
					/>
					<Field
						component={Checkbox}
						id="tvTruck"
						isDisabled={isDisabled}
						label="TV Truck"
						name={JobUpsertFM.getAttributeName('tvTruck')}
					/>
					<Field
						component={Checkbox}
						id="tvLateralTk"
						isDisabled={isDisabled}
						label="TV Lateral Tk"
						name={JobUpsertFM.getAttributeName('tvLateralTk')}
					/>
					<Field
						component={Checkbox}
						id="tvGroutTk"
						isDisabled={isDisabled}
						label="TV Grout Tk"
						name={JobUpsertFM.getAttributeName('tvGroutTk')}
					/>
					<Field
						component={Checkbox}
						id="tvLatGroutTk"
						isDisabled={isDisabled}
						label="TV Lat Grout Tk"
						name={JobUpsertFM.getAttributeName('tvLatGroutTk')}
					/>
					<Field
						component={Checkbox}
						id="tvSonarTk"
						isDisabled={isDisabled}
						label="TV Sonar Tk"
						name={JobUpsertFM.getAttributeName('tvSonarTk')}
					/>
					<Field
						component={Checkbox}
						id="tvPolaris"
						isDisabled={isDisabled}
						label="TV Polaris"
						name={JobUpsertFM.getAttributeName('tvPolaris')}
					/>
					<Field
						component={Checkbox}
						id="tvLCRTk"
						isDisabled={isDisabled}
						label="TV LCR Tk"
						name={JobUpsertFM.getAttributeName('tvLCRTk')}
					/>
				</div>
				<div className={columnClassName}>
					<Field
						component={Checkbox}
						id="tvLateralReinstator"
						isDisabled={isDisabled}
						label="TV Lateral Reinstator"
						name={JobUpsertFM.getAttributeName('tvLateralReinstator')}
					/>
					<Field
						component={Checkbox}
						id="tvMTHTk"
						isDisabled={isDisabled}
						label="TV MTH Tk"
						name={JobUpsertFM.getAttributeName('tvMTHTk')}
					/>
					<Field
						component={Checkbox}
						id="tvLaserTk"
						isDisabled={isDisabled}
						label="TV Laser Tk"
						name={JobUpsertFM.getAttributeName('tvLaserTk')}
					/>
					<Field
						component={Checkbox}
						id="minicam"
						isDisabled={isDisabled}
						label="Minicam"
						name={JobUpsertFM.getAttributeName('minicam')}
					/>
					<Field
						component={Checkbox}
						id="vacTk"
						isDisabled={isDisabled}
						label="Vac Tk"
						name={JobUpsertFM.getAttributeName('vacTk')}
					/>
					<Field
						component={Checkbox}
						id="hivacTk"
						isDisabled={isDisabled}
						label="HiVac Tk"
						name={JobUpsertFM.getAttributeName('hivacTk')}
					/>
					<Field
						component={Checkbox}
						id="hiRailvacTk"
						isDisabled={isDisabled}
						label="HiRail Vac Tk"
						name={JobUpsertFM.getAttributeName('hiRailvacTk')}
					/>
					<Field
						component={Checkbox}
						id="tanker"
						isDisabled={isDisabled}
						label="Tanker"
						name={JobUpsertFM.getAttributeName('tanker')}
					/>
				</div>
				<div className={columnClassName}>
					<Field
						component={Checkbox}
						id="wb"
						isDisabled={isDisabled}
						label="WB"
						name={JobUpsertFM.getAttributeName('wb')}
					/>
					<Field
						component={Checkbox}
						id="hwBoiler"
						isDisabled={isDisabled}
						label="HW Boiler"
						name={JobUpsertFM.getAttributeName('hwBoiler')}
					/>
					<Field
						component={Checkbox}
						id="pressureWash"
						isDisabled={isDisabled}
						label="Pressure Wash"
						name={JobUpsertFM.getAttributeName('pressureWash')}
					/>
					<Field
						component={Checkbox}
						id="airComp"
						isDisabled={isDisabled}
						label="Air Compressor"
						name={JobUpsertFM.getAttributeName('airComp')}
					/>
					<Field
						component={Checkbox}
						id="clamTk"
						isDisabled={isDisabled}
						label="Clam Tk"
						name={JobUpsertFM.getAttributeName('clamTk')}
					/>
					<Field
						component={Checkbox}
						id="bucketMach"
						isDisabled={isDisabled}
						label="Bucket Mach"
						name={JobUpsertFM.getAttributeName('bucketMach')}
					/>
					<Field
						component={Checkbox}
						id="mhRehabTk"
						isDisabled={isDisabled}
						label="MH Rehab Tk"
						name={JobUpsertFM.getAttributeName('mhRehabTk')}
					/>
					<Field
						component={Checkbox}
						id="microtrax"
						isDisabled={isDisabled}
						label="Microtrax"
						name={JobUpsertFM.getAttributeName('microtrax')}
					/>
				</div>
				<div className={columnClassName}>
					<Field
						component={Checkbox}
						id="smallEasementMachine"
						isDisabled={isDisabled}
						label="Small Easement Machine"
						name={JobUpsertFM.getAttributeName('smallEasementMachine')}
					/>
					<Field
						component={Checkbox}
						id="bigEasementMachine"
						isDisabled={isDisabled}
						label="Big Easement Machine"
						name={JobUpsertFM.getAttributeName('bigEasementMachine')}
					/>
					<Field
						component={Checkbox}
						id="arrowBoard"
						isDisabled={isDisabled}
						label="Arrow Board"
						name={JobUpsertFM.getAttributeName('arrowBoard')}
					/>
					<Field
						component={Checkbox}
						id="supportTk"
						isDisabled={isDisabled}
						label="Support Tk"
						name={JobUpsertFM.getAttributeName('supportTk')}
					/>
					<Field
						component={Checkbox}
						id="rollOffTk"
						isDisabled={isDisabled}
						label="Roll Off Tk"
						name={JobUpsertFM.getAttributeName('rollOffTk')}
					/>
					<Field
						component={Checkbox}
						id="pump"
						isDisabled={isDisabled}
						label="Pump"
						name={JobUpsertFM.getAttributeName('pump')}
					/>
					<Field
						component={Checkbox}
						id="pigLaunch"
						isDisabled={isDisabled}
						label="Pig Launch"
						name={JobUpsertFM.getAttributeName('pigLaunch')}
					/>
					<Field
						component={Checkbox}
						id="stoveMach"
						isDisabled={isDisabled}
						label="Stove Mach"
						name={JobUpsertFM.getAttributeName('stoveMach')}
					/>
				</div>
				<div className={columnClassName}>
					<Field
						component={Checkbox}
						id="powerRodder"
						isDisabled={isDisabled}
						label="Power Rodder"
						name={JobUpsertFM.getAttributeName('powerRodder')}
					/>
					<Field
						component={Checkbox}
						id="reeferTruck"
						isDisabled={isDisabled}
						label="Reefer Truck"
						name={JobUpsertFM.getAttributeName('reeferTruck')}
					/>
					<Field
						component={Checkbox}
						id="lateralReinstatorTrailer"
						isDisabled={isDisabled}
						label="Lateral Reinstator Trailer"
						name={JobUpsertFM.getAttributeName('lateralReinstatorTrailer')}
					/>
					<Field
						component={Checkbox}
						id="steamCureTruck"
						isDisabled={isDisabled}
						label="Steam Cure Truck"
						name={JobUpsertFM.getAttributeName('steamCureTruck')}
					/>
					<Field
						component={Checkbox}
						id="airTesting"
						isDisabled={isDisabled}
						label="Air Testing"
						name={JobUpsertFM.getAttributeName('airTesting')}
					/>
					<Field
						component={Checkbox}
						id="trackMachine"
						isDisabled={isDisabled}
						label="Track Machine"
						name={JobUpsertFM.getAttributeName('trackMachine')}
					/>
					{
						!isDisabled &&
						<FieldArray<void>
							component={AdditionalTrucksAndEquipment}
							name={JobUpsertFM.getAttributeName('additionalTruckEquipmentFields')}
						/>
					}
				</div>
			</div>
			<div className={[formSectionClassRow, styles['job-form__trucks-and-equipment__number-of-employees']].join(' ')}>
				<div className={styles['job-form__trucks-and-equipment__number-of-employees__label']}>
					Number of People needed on Job:
				</div>
				<div className={fieldColumnClassName}>
					<Field
						className={styles['job-form__trucks-and-equipment__number-of-employees__field']}
						component={Input}
						disabled={isDisabled}
						id="numberOfEmployees"
						isZeroIfEmpty={true}
						name={JobUpsertFM.getAttributeName('numberOfEmployees')}
						type="number"
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(TrucksAndEquipmentSection);
